export const tradingPostKeys = [
    ':water:',
    'Azure',
    ':brick:',
    'Camo',
    ':carrot:',
    ':cloud:',
    'Crim',
    'Deep',
    'Faded',
    'Grass',
    ':ice:',
    'Live',
    'Mid',
    ':pinkHeart:',
    'Plum',
    ':rose:',
    'Sepia',
    ':snowflake:',
    ':sun:',
    'Viol',
];
